

export function send_tracking_event(action, tracking_id) {
    if (false) {
        return;
    }
    gtag('event', 'odoscope', {
        action,
        tracking_id
    });
}